
import React, { createContext, useContext } from 'react';
import { AuthContextType } from './types';
import { supabase } from "@/integrations/supabase/client";

// Create the context with a default value
export const AuthContext = createContext<AuthContextType>({
  isAuthenticated: false,
  currentUser: null,
  loading: true,
  isAdmin: false,
  supabaseClient: supabase, // Add the supabaseClient to the default context value
  login: async () => ({ success: false, error: 'Not implemented' }),
  logout: async () => {},
  signup: async () => ({ success: false, error: 'Not implemented' }),
});

// Custom hook to use the auth context
export const useAuth = () => {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error('useAuth must be used within an AuthProvider');
  }
  
  // Add debug log when the context is accessed
  console.log('useAuth hook called - isAdmin:', context.isAdmin);
  
  return context;
};
